module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "id px-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.brandZone.zone.id))])]), _vm._v(" "), _c('td', {
    staticClass: "ref px-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.brandZone.zone.refClient ? _vm.brandZone.zone.refClient : "-"))])]), _vm._v(" "), _c('td', {
    staticClass: "name px-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.brandZone.zone.name))])]), _vm._v(" "), _c('td', {
    staticClass: "type px-3"
  }, [(_vm.brandZone.active) ? _c('span', [_vm._v(" " + _vm._s(_vm.brandZone.zoneRelationType.name) + " ")]) : _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.$trad.headerAdmin.zone.deleted) + ")")])])]), _vm._v(" "), _c('td', {
    staticClass: "group px-3"
  }, [(_vm.brandZone.zoneGroupsRights) ? _c('span', [_vm._v(" " + _vm._s(_vm.brandZone.zoneGroupsRights.name) + " ")]) : _c('span', [_vm._v(" - ")])]), _vm._v(" "), _c('td', {
    staticClass: "brands px-3"
  }, [_c('span', [_vm._l((_vm.brandZone.brands), function(brand, key) {
    return [(key === 0) ? [_vm._v(_vm._s(brand.name))] : [_vm._v(_vm._s(" • " + brand.name))]]
  })], 2)]), _vm._v(" "), _c('td', {
    staticClass: "users text-center px-3"
  }, [_c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.emit('showUsers');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.brandZone.zone.users.length) + " ")])]), _vm._v(" "), (_vm.canManageZone()) ? _c('td', {
    staticClass: "edit-type text-center px-3"
  }, [_c('img', {
    staticClass: "position-relative",
    attrs: {
      "src": require("../../../assets/edit_type.svg"),
      "alt": "edit-type"
    },
    on: {
      "click": function($event) {
        _vm.emit('editTypeZone');
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "edit text-center px-3"
  }, [_c('img', {
    staticClass: "position-relative",
    attrs: {
      "src": require("../../../assets/edit.svg"),
      "alt": "edit"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/zones/zone/' + _vm.brandZone.zone.id
        });
      }
    }
  })]), _vm._v(" "), (_vm.canManageZone()) ? _c('td', {
    staticClass: "delete shrink text-center px-3"
  }, [(_vm.brandZone.active) ? _c('img', {
    staticClass: "position-relative",
    attrs: {
      "src": require("../../../assets/delete.svg"),
      "alt": "delete"
    },
    on: {
      "click": function($event) {
        _vm.emit('deleteZone');
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "history text-center px-3"
  }, [_c('History', {
    attrs: {
      "object": _vm.brandZone.zone,
      "object-type": _vm.OBJECT_TYPE.ZONES
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42ca8e52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zone/ZoneDetailBanner.vue
// module id = 3147
// module chunks = 0